import Colors from './Colors'
import Space from './Space'
import Fonts from './Fonts'
import FontSizes from './FontSizes'
import FontWeights from './FontWeights'
import LineHeights from './LineHeights'

export default {
  Colors,
  Space,
  Fonts,
  FontSizes,
  FontWeights,
  LineHeights,
}
